module.exports = __webpack_public_path__ + "static/img/twjd-sde17.583089c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde17.png
// module id = 837
// module chunks = 0